import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

// const images = [
//   '//placekitten.com/1500/500',
//   '//placekitten.com/4000/3000',
//   '//placekitten.com/800/1200',
//   '//placekitten.com/1500/1500',
// ];

export default class LightboxExample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: this.props.photoIndex ? this.props.photoIndex:0,
      isOpen: false,
    };
  }
  render() {
    const { images } = this.props;
    const { photoIndex, isOpen } = this.state;
    return (
      <div>
        <span onClick={() => this.setState({ isOpen: true, photoIndex: this.props.photoIndex })}>
          {this.props.clickable}
        </span>
        {isOpen && (
          <Lightbox
            reactModalStyle={{content : {top:"50px"}}}
            mainSrc={images[photoIndex]}
            nextSrc={images[photoIndex+1]}
            prevSrc={images[photoIndex-1]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: photoIndex-1,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: photoIndex+1,
              })
            }
          />
        )}
      </div>
    );
  }
}